var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.announcement && !_vm.isWhiteLabel)?_c('BaseNotification',{staticClass:"aha-public-announcement",class:[
    `critical-${_vm.announcement && _vm.announcement.criticalLevel}`,
    {
      '--fixed': _vm.isFixed,
    },
  ],attrs:{"showCloseButton":true,"showActions":false,"loading":_vm.isLoadingConfiguration,"zIndex":-_vm.zIndex}},[_c('div',{domProps:{"innerHTML":_vm._f("sanitize")(_vm.announcement.content,true, false)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }